import { useEnableSenderEmails } from '../../../feature-flags/hooks/use-enable-sender-emails';
import { useIsSellerFeatureEnabled } from '../../../hooks/use-is-seller-feature-enabled';
import { SellerFeatures } from '../../../enums/seller-features';

export const useIsSenderEmailsEnabledForSeller = () => {
  const isFeatureFlagEnabled = useEnableSenderEmails();
  const isSellerFeatureEnabled = useIsSellerFeatureEnabled(SellerFeatures.BrandedDomains);

  return isFeatureFlagEnabled && isSellerFeatureEnabled;
};
